import { FirearmService } from '../model/firearm.service';
import { CrudDataSource, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { Firearm } from 'assets-model';
import { Observable } from 'rxjs';


export class FirearmDataSource extends CrudDataSource<Firearm> {

  constructor(private service: FirearmService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<Firearm>> {
    return this.service.findByFullFilters(serviceArguments, pageSpec);
  }

}


